
<form class="member-editor-form" [formGroup]="formG1">

	<!-- 
		<h2>Fragebogen für den gesamten Versicherungsbestand</h2>
		<h2 *ngIf="member.mitgliedsname">{{member.mitgliedsname}} ({{member.mitgliedsnummer}})</h2> 
	-->

	<div class="rectPanel">
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.mitgliedsname" />
			<triv-input [fGroup]="formG1" [data]="myInputs.mitgliedsnummer" />
		</div>
	</div>

	<div class="rectPanel">

		<div class="aSubTitle">
			Ansprechpartner
		</div>

		<div>
			<mat-form-field appearance="outline" subscriptSizing="dynamic" style="width: 100%;">
				<mat-label>Ansprechpartner</mat-label>
				<mat-select [formControl]="mainContactCtrl" [disabled]="true">
					@if( !users || !users.length ) {
						<mat-option disabled>
							Dieses Mitglied hat noch keine Benutzer
						</mat-option>
					}
					@else {
						@for( user of users; track user.ebeId ) {
							<mat-option [value]="user.ebeId">
								{{ usernames[ user.ebeId ] }}
							</mat-option>
						}
					}
				</mat-select>
				<mat-hint>
					Hinweis: Ansprechpartner und Kontaktdaten werden automatisch aus dem zugeordneten Benutzer übernommen und können in der Benutzerverwaltung gepflegt werden.
				</mat-hint>
			</mat-form-field>
		</div>

		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formReadonly" [data]="myInputs.mainContactName"></triv-input>
			<triv-input [fGroup]="formReadonly" [data]="myInputs.mainContactPhone"></triv-input>
		</div>
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formReadonly" [data]="myInputs.mainContactEmail"></triv-input>
		</div>

	</div>

	<div class="rectPanel">

		<div class="aSubTitle">
			Anschrift der Gesellschaft
		</div>
		<triv-input [fGroup]="formG1" [data]="myInputs.gsStrasse"></triv-input>
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.gsOrt"></triv-input>
			<triv-input [fGroup]="formG1" [data]="myInputs.gsPLZ"></triv-input>
		</div>
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.gsTelefon"></triv-input>
			<triv-input [fGroup]="formG1" [data]="myInputs.gsFax"></triv-input>
		</div>
		<div class="inputRowScreenColPhone">
			<triv-input [fGroup]="formG1" [data]="myInputs.gsWebAdesse"></triv-input>
			<triv-input [fGroup]="formG1" [data]="myInputs.gsEmail"></triv-input>
		</div> 

	</div>

	<div class="rectPanel">

		<div class="aSubTitle">
			Kategorien
		</div>

		@if( !categoryInputs.length ) {
			<div class="noElements" style="margin: 0 .5em">
				<span>Keine Kategorien</span>
			</div>
		}
		@else{
			@for( categoryInput of categoryInputs; track categoryInput.id ) {
				<div>
					<triv-input [fGroup]="formG1" [data]="categoryInput" />
				</div>
			}
		}

	</div>

	@if( bAdmin ) {

		@if( environment.features.sparten ) {

			<div class="rectPanel">
				<div class="aSubTitle">
					Sparten
				</div>
				@if( !sections.length ) {
					<div class="noElements" style="margin: 0 .5em">
						Keine Sparten
					</div>
				}
				@else {
					<div [formGroup]="formSections">
						@for( s of sections; track s.sparteId ) {
							<div>
								<mat-checkbox [formControlName]="s.sparteId">
									{{s.sparteBezeichnung}}
								</mat-checkbox>
							</div>
						}
					</div>
				}
			</div>

		}

		<div class="rectPanel">
			<div class="aSubTitle">
				Dateigruppen
			</div>
			@if( !groups.length ) {
				<div class="noElements" style="margin: 0 .5em">
					Keine Gruppen
				</div>
			}
			@else {
				<div [formGroup]="formDateiGruppen">
					@for( g of groups; track g.gruppenId ) {
						<div>
							<mat-checkbox [formControlName]="g.gruppenId">
								{{g.gruppenname}}
							</mat-checkbox>
						</div>
					}
				</div>
			}
		</div>

		@if( environment.features.austausch ) {

			<div class="rectPanel">
				<div class="aSubTitle">
					Austauschkategorien
				</div>
				@if( !documentExchangeCategories.length ) {
					<div class="noElements" style="margin: 0 .5em">
						Kein Austausch
					</div>
				}
				@else {
					<div [formGroup]="formDEC">
						@for( dec of documentExchangeCategories; track dec.id ) {
							<div>
								<mat-checkbox [formControlName]="dec.id">
									{{dec.name}}
								</mat-checkbox>
							</div>
						}
					</div>
				}
			</div>

		}

	}
		
	@if( !member.mitgliedId ) {

		<div style="margin: 2em 0; display: grid; grid-template-columns: 1fr 1fr 1fr; justify-content: center; gap: 30px;">

			<button
				mat-raised-button 
				(click)="cancel()"
				[disabled]="bSaveInProgress"
			>
				<mat-icon>home</mat-icon>
				Abbrechen
			</button>
	
			<button
				mat-raised-button 
				(click)="reset()"
				[disabled]="bSaveInProgress || (formG1.pristine && formSections.pristine)"
			>
				<mat-icon>history</mat-icon>
				Zurücksetzen
			</button>
	
			<button
				mat-raised-button
				(click)="createMember()" 
				[disabled]="bSaveInProgress || formG1.pristine || !formG1.valid || (environment.features.sparten && !formSections.valid)"
			>
				<mat-icon>save</mat-icon>
				Erstellen
			</button>
	
		</div>

	}

</form>
